// src/components/GlobalLoader.tsx
import { useSelector } from 'react-redux';
import Loader from './utils/Loader';
import { Box } from '@mui/material';

interface RootState {
  loading: {
    isLoading: boolean;
  };
}

export const GlobalLoader = () => {
  const isLoading = useSelector((state: RootState) => state.loading.isLoading);

  if (!isLoading) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: 'white',
        zIndex: 9999, // Ensures it's above all other content
      }}>
      <Loader size={60} speed={3} text="Loading..." />
    </Box>
  );
};
